import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../context/AuthContext'
import { authService } from '../services/apiService'

const Profile = () => {
  const { user, checkAuth } = useContext(AuthContext)
  const [editing, setEditing] = useState(false)
  const [profileData, setProfileData] = useState({
    bio: '',
    phone: '',
    address: '',
  })

  useEffect(() => {
    if (user?.profile) {
      setProfileData({
        bio: user.profile.bio || '',
        phone: user.profile.phone || '',
        address: user.profile.address || '',
      })
    }
  }, [user])

  const handleChange = (e) => {
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await authService.updateProfile(profileData)
      await checkAuth()
      setEditing(false)
      alert('Profile updated successfully!')
    } catch (error) {
      console.error('Error updating profile:', error)
      alert('Failed to update profile. Please try again.')
    }
  }

  return (
    <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8'>
      <div className='bg-white shadow rounded-lg'>
        <div className='px-6 py-5 border-b border-gray-200'>
          <h2 className='text-2xl font-bold text-gray-900'>My Profile</h2>
        </div>

        <div className='px-6 py-6'>
          <div className='space-y-6'>
            <div>
              <h3 className='text-lg font-medium text-gray-900 mb-4'>
                Personal Information
              </h3>
              <dl className='grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2'>
                <div>
                  <dt className='text-sm font-medium text-gray-500'>
                    First Name
                  </dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    {user?.first_name}
                  </dd>
                </div>
                <div>
                  <dt className='text-sm font-medium text-gray-500'>
                    Last Name
                  </dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    {user?.last_name}
                  </dd>
                </div>
                <div>
                  <dt className='text-sm font-medium text-gray-500'>Email</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{user?.email}</dd>
                </div>
                <div>
                  <dt className='text-sm font-medium text-gray-500'>Role</dt>
                  <dd className='mt-1 text-sm text-gray-900 capitalize'>
                    {user?.role}
                  </dd>
                </div>
              </dl>
            </div>

            <div className='border-t border-gray-200 pt-6'>
              <div className='flex items-center justify-between mb-4'>
                <h3 className='text-lg font-medium text-gray-900'>
                  Additional Information
                </h3>
                {!editing && (
                  <button
                    onClick={() => setEditing(true)}
                    className='bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700'
                  >
                    Edit Profile
                  </button>
                )}
              </div>

              {editing ? (
                <form onSubmit={handleSubmit} className='space-y-4'>
                  <div>
                    <label className='block text-sm font-medium text-gray-700'>
                      Bio
                    </label>
                    <textarea
                      name='bio'
                      rows='3'
                      className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500'
                      value={profileData.bio}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700'>
                      Phone
                    </label>
                    <input
                      type='tel'
                      name='phone'
                      className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500'
                      value={profileData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700'>
                      Address
                    </label>
                    <textarea
                      name='address'
                      rows='2'
                      className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500'
                      value={profileData.address}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='flex space-x-3'>
                    <button
                      type='submit'
                      className='bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700'
                    >
                      Save Changes
                    </button>
                    <button
                      type='button'
                      onClick={() => setEditing(false)}
                      className='bg-gray-300 text-gray-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-400'
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <dl className='space-y-4'>
                  <div>
                    <dt className='text-sm font-medium text-gray-500'>Bio</dt>
                    <dd className='mt-1 text-sm text-gray-900'>
                      {user?.profile?.bio || 'No bio added yet.'}
                    </dd>
                  </div>
                  <div>
                    <dt className='text-sm font-medium text-gray-500'>Phone</dt>
                    <dd className='mt-1 text-sm text-gray-900'>
                      {user?.profile?.phone || 'No phone number added yet.'}
                    </dd>
                  </div>
                  <div>
                    <dt className='text-sm font-medium text-gray-500'>
                      Address
                    </dt>
                    <dd className='mt-1 text-sm text-gray-900'>
                      {user?.profile?.address || 'No address added yet.'}
                    </dd>
                  </div>
                </dl>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
